import { MdsSkeleton } from "@/design-system/components/loader/MdsSkeleton";

const NOTE_SKELETON_DELAY = 1000;

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export function NoteSkeleton({ delay = NOTE_SKELETON_DELAY }: { delay?: number }) {
  return (
    <div>
      <h1>
        <MdsSkeleton delay={delay} />
      </h1>
      <p>
        <MdsSkeleton count={3} delay={delay} />
      </p>
      <p>
        <MdsSkeleton count={5} delay={delay} />
      </p>
    </div>
  );
}
